(function ($) {




    Vue.http.headers.common['X-CSRF-TOKEN'] = faculty.html.data('token');

    // Profile Tooltips
    // ===================================//
    var $info = $('[data-toggle="tooltip"]');
    $info.tooltip();

    // Popover Initialization
    // ===================================//
    var $pop = $('[data-toggle="popover"]');
    $pop.popover();

    // Set Typeahead
    // ===================================//
    var $typeahead = $(".chosen-select");
    $typeahead.chosen();

    // // Profile: Load Courses
    // // ===================================//
    if ($('#courses-container').length > 0) {
        let i, classesLength;
        let form = $('#course-list-form');
        let container = $('#courses-container');
        let selected = $('#courses-archive').find(":selected").val();
        let uri = form.attr('action') + '/' + selected + '/' + "classes";
        $.ajax(
            {
                type: "GET",
                url: uri,
                processData: false,
                contentType: false,
                success: function (data) {
                    container.html(data);
                },
                error: function () {
                    container.html('<tr><td data-title="Information:" colspan="7">Data for this term is currently unavailable.</td></tr>');
                }
            });
    }

    // // Profile: Load Office Hours
    // // ===================================//
    if ($('#office-hours').length > 0) {
        var i2 = null, officeHoursLength = null;
        var form2 = $('#office-hours-list-form');
        var container2 = $('#office-hours');
        var selected2 = $('#terms-archive').find(":selected").val();
        var uri2 = form2.attr('action') + '/' + selected2 + '/' + "office-hours";
        $.ajax(
            {
                type: "GET",
                dataType: 'json',
                url: uri2,
                processData: false,
                contentType: false,
                success: function (person) {
                    container2.html(makeProfileOfficeHoursMarkup(person));
                },
                error: function () {
                    container2.html('<tr><td data-title="Information:" colspan="7">Data for this term is currently unavailable.</td></tr>');
                }
            });
    }

// Admin Dashboard Nav bar
    $(document).ready(function () {
        var sideslider = $('[data-toggle=collapse-side]');
        var sel = sideslider.attr('data-target');
        var sel2 = sideslider.attr('data-target-2');
        sideslider.click(function (event) {
            $(sel).toggleClass('in');
            $(sel2).toggleClass('out');
        });
    });



    // Stories: Content Slides
    // ===================================//

    $(".content-slides").each(function (i, area) {
        var $area = $(this);

        $(".img-panel", $area).each(function (j, img) {
            var $img = $(this), x = Math.round($img.position().left),

                w = $img.outerWidth(), right = x + w,
                left = x - w;

            $area.scroll(function (e) {
                var sx = $(this).scrollLeft(), opac = .65;

                if (sx <= right && sx >= left) {
                    if (sx >= left && sx <= x) {
                        if (left < 0) {
                            sx = w - (x - sx);
                        } else {
                            sx -= left;
                        }

                        pct = sx / w;
                    } else {
                        delta = right - sx;
                        pct = delta / w;
                    }

                    opac += (.8 * pct);
                }
                $img.css("opacity", opac);
            }).scroll();
        });
    });

    // Profile edit: Biography character constraint
    // ========================================
    if (faculty.body.hasClass('profile-info')) {
        var Biography = new Vue({
            el: "#person-bio",
            data: {
                charLimit: 1500,
                bio: ""
            },
            methods: {
                setCharLimit: function () {
                    if (this.bio.length > this.charLimit) {
                        this.bio = this.bio.substr(0, this.charLimit);
                    }
                }
            }
        });
    }

    // Vue with Chosen Directive
    Vue.directive('chosen', {
        twoWay: true,
        bind: function () {
            $(this.el)
                .chosen({
                    inherit_select_classes: true,
                    width: '30%',
                    disable_search_threshold: 999
                })
                .change(function (ev) {
                    // Grab the expertise name
                    var name = $(this.el).find(':selected').data('name');
                    // two-way set
                    this.set({'expertise_id': this.el.value, 'title': name});
                }.bind(this));
        },
        update: function (nv, ov) {
            // note that we have to notify chosen about update
            $(this.el).trigger("chosen:updated");
        }
    });

    // Profile Edit: Research Interests
    // ========================================

    if (faculty.body.hasClass('research')) {

        var Expertise = new Vue({

            el: "#research-interests",
            data: {
                newExpertise: [],
                currentExpertise: []

            },
            ready: function () {
                this.fetchExpertise();
            },
            methods: {
                fetchExpertise: function () {
                    this.$http.get('get-expertise', {}, function (data) {
                        this.$set('currentExpertise', data);
                    });
                },
                addExpertise: function () {
                    this.currentExpertise.push(this.newExpertise);
                    this.$http.get('attach-expertise?expertise=' + this.newExpertise.expertise_id, function (expertise) {
                    });
                },
                removeExpertise: function (expertise) {
                    this.currentExpertise.$remove(expertise);
                    this.$http.get('detach-expertise?expertise=' + expertise.expertise_id, function () {
                    });
                }
            }
        });
    }

    // Profile Courses: Add Syllabi
    // Sets the class number to hidden for input in modal
    // ===================================//
    $('.syllabi-upload-button').click(function (event) {
        $('#syllabusForm input[name="class_number"]').val($(event.target).data('class-number'));
    });

    // Profiles: Assign By Appointment Only
    // ===================================//

    function registerOfficeHourEvents() {
        var form_id = 'office-hours-form';

        $('#' + form_id + ' input[name="type"]').change(function (e) {
            if ($(this).val() == "appointment") {
                $('#' + form_id + ' .office-hours-input').css('display', 'none');
            }
            else {
                $('#' + form_id + ' .office-hours-input').css('display', 'block');
            }
        });

        $('#' + form_id + ' input[name="type"]:checked').triggerHandler('change');
    }

    // register the office hour events
    registerOfficeHourEvents();


    // Profiles: Format and Return Office Hours Markup
    function makeProfileOfficeHoursMarkup(person) {
        if (person.officehours.length > 0) {
            var items = "";
            $(person.officehours).each(function (i, element) {
                if (element.formatted_days) {
                    items += '<tr><td>' + element.formatted_days + '</td><td>' + element.start_time + ' - ' + element.end_time
                        + '</td><td><a href="javascript:void(0);" data-modal="#waldoMap" data-waldo-event-trigger="click">' + element.location + '</a></td><td>' + (element.description ? element.description : '--') + '</td></tr>';
                }
                else {
                    items += '<tr><td colspan="4" class="text-center">By Appointment Only</td></tr>';
                }
            });

            return items;
        } else {
            var noOfficeHours = '<tr><td data-title="Information:" colspan="4">' + person.display_name
                + " has not added any office hours for " + $('#terms-archive option:selected').text() + ".</td></tr>";
            return noOfficeHours;
        }
    }


    // Profiles: Image Cropper
    // ===================================//
    function registerJCropEvents() {

        var defaultWidth = Math.min($('#cropw').val(), 200);
        var defaultHeight = Math.min($('#croph').val(), 200);

        $('#cropImage').Jcrop({
            aspectRatio: 1,
            setSelect: [0, 0, defaultWidth, defaultHeight]
        });

        $('#cropImageContainer').on('cropend', function (e, s, c) {
            updateCoords(c);
        });
    }

    function updateCoords(c) {
        $('#cropx').val(c.x);
        $('#cropy').val(c.y);
        $('#cropw').val(c.w);
        $('#croph').val(c.h);
    };

    // register the JCrop events
    registerJCropEvents();


// Classses terms changed
    $('#courses-archive').change(function () {
        var form = $('#course-list-form');
        var container = $('#courses-container');
        var selected = $('#courses-archive').find(":selected").val();
        var uri = form.attr('action') + '/' + selected + '/' + "classes";
        $('.course-loading').show();
        container.hide();
        $.ajax(
            {
                type: "GET",
                data: "data",
                url: uri,
                success: function (data, textStatus, jqXHR) {
                    container.html("");
                    container.html(data);
                },
                complete: function () {
                    $('.course-loading').hide();
                    container.show();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    container.html('<tr><td data-title="Information:" colspan="7">Data for this term is currently unavailable.</td></tr>');
                },
            });
    });

    // office terms changed
    $('#terms-archive').change(function () {
        var form2 = $('#office-hours-list-form');
        var container2 = $('#office-hours');
        var selected2 = $('#terms-archive').find(":selected").val();
        var uri2 = form2.attr('action') + '/' + selected2 + '/' + "office-hours";
        $('.office-loading').show();
        container2.hide();
        $.ajax(
            {
                type: "GET",
                dataType: "json",
                url: uri2,
                success: function (person, textStatus, jqXHR) {
                    container2.html(makeProfileOfficeHoursMarkup(person));
                },
                complete: function () {
                    $('.office-loading').hide();
                    container2.show();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    container2.html('<tr><td data-title="Information:" colspan="7">Data for this term is currently unavailable.</td></tr>');
                }
            });
    });

    var emeritiTableSortOptions = {
        valueNames: ['display_name', 'appt_year', 'department_name']
    };

    $('#printEmeriti').on('click', function () {
        var emeritiList = new List('emeriti-list', emeritiTableSortOptions);
        var printContents = document.getElementById('printableArea').innerHTML;
        var originalContents = document.documentElement.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        location.reload();
    });

    $('#sort-options').on('click', '.sort', function () {
        var sylibi = new List('sylibi-list', {
            valueNames: ['display_name', 'course_name', 'section_num', 'syllabus']
        });
        var sort;
        var $this = $(this);
        var ascOrder = $this.hasClass('asc') ? 'asc' : 'desc';
        var sortName = $this.data('sort');
        sort = sortName + '.' + ascOrder;
    });

    $('.removeEntityMember').click(function () {
        var name = $(this).data('name');
        var email = $(this).data('email');
        var entity = $(this).data('entity');
        var connectID = $(this).data('connect-id');
        $('.displayName').html(name);
        $('#entityName').html(entity);
        var URL = faculty.env.url + '/dashboard/' + entity + '/' + connectID + '/manage-' + entity + '/' + email;
        console.log(URL);
        $('#removeEntityModal form').attr('action', URL);
    });

    $('.updateEntityRole').click(function () {
        var name = $(this).data('name');
        name = convertToPlural(name);
        var email = $(this).data('email');
        var entity = $(this).data('entity');
        var connectID = $(this).data('connect-id');
        var role = $(this).data('role');
        role = role.split(' ').join('_');
        //Database returns role as uppercase first letter role so we must convert to all lowercase to match array
        role = role.toLowerCase();
        $('#entity-role-update').val(role);
        $('.displayName').html(name);
        $('#entityName').html(entity);
        var URL = faculty.env.url + '/dashboard/' + entity + '/' + connectID + '/manage-' + entity + '/' + email;
        $('#updateRoleModal form').attr('action', URL);
    });

    $('.removeCommitteeMember').click(function () {
        var name = $(this).data('name');
        var email = $(this).data('email');
        var connectID = $(this).data('connect-id');
        $('.committeeMemberName').html(name);
        var URL = faculty.env.url + '/dashboard/committee/' + connectID + '/manage-committee/' + email;
        $('#remove-committee-member-modal form').attr('action', URL);
    });

    $('#department-number').change(function () {
        var selected = $(this).find(":selected").val();
        var inputValue = $('#retrieveDepartment');
        var uri = faculty.env.url + '/api/' + selected + '/department_number';
        //$('.course-loading').show();
        $.ajax(
            {
                type: "GET",
                data: "data",
                url: uri,
                success: function (data, textStatus, jqXHR) {
                    $(inputValue).val(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                },
            });
    });

    $('.updateCommitteeRole').click(function () {
        var name = $(this).data('name');
        name = convertToPlural(name);
        var email = $(this).data('email');
        var connectID = $(this).data('connect-id');
        var role = $(this).data('role');
        role = role.split(' ').join('_');
        //Database returns role as uppercase first letter role so we must convert to all lowercase to match array
        role = role.toLowerCase();
        $('#committeeSelectRoleUpdate').val(role);
        $('.committeeMemberName').html(name);
        var URL = faculty.env.url + '/dashboard/committee/' + connectID + '/manage-committee/' + email;
        $('#update-committee-role-modal form').attr('action', URL);
    });

    function convertToPlural(str) {
        if (str.slice(-1) == 's')
            return str + "'";
        else
            return str + "'s";
    }

})(jQuery);
